import fixDate from "@/common/fix-date";
import IRoom from "@/models/rooms/iroom";
import { get, post, put, remove } from "./base-service";
import ITrip from "@/models/trips/itrip";
import ITripSearchResult from "@/models/trips/itrip-search-result";

const baseUrl = "trips"

export async function getRoomsWithTrips(id: string): Promise<IRoom[]> {
    const response = await get(`${baseUrl}/retreat`, id);

    return response.json();
}

export async function getTrip(id: number): Promise<ITrip> {
    const response = await get(baseUrl, id);

    return response.json();
}

export async function getTrips(guestId: number): Promise<ITripSearchResult[]> {
    const response = await get(`${baseUrl}/guest`, guestId);

    return response.json();
}

export async function updateTrip(trip: ITrip): Promise<boolean> {
    const newTrip = {
        ...trip,
        reservationDate: fixDate(trip.reservationDate)
    }

    const response = await put(baseUrl, newTrip);
    
    return response.ok;
}

export async function addTrip(trip: ITrip): Promise<ITrip | number> {
    const newTrip = {
        ...trip,
        reservationDate: fixDate(trip.reservationDate),
        tripPayments: trip.tripPayments?.map((x, i) => {
            x.id = i;
            x.paymentDate = new Date(fixDate(x.paymentDate) ?? "");
            return x;
        }) ?? []
    }

    const response = await post(baseUrl, newTrip);

    return response.json();
}

export async function deleteTrip(tripId: number, guestId: number): Promise<boolean> {
    const response = await remove(baseUrl, `guest/${guestId}/trip/${tripId}`);

    return response.json();
}